import React, {Component} from "react";
import { 
    Modal,
    Button,
    FormGroup,
    ControlLabel,
    Alert
} from "react-bootstrap";
import CurrencyInput from "components/CurrencyInput/CurrencyInput";
import DatePicker from "react-datepicker";


class CustomValueModal extends Component {

    constructor(props) {
        super(props)
        this.state = {
            customValue: {
                _id: '',
                period: '',
                extraPagIbig: ''
            }
        }
    }

    componentWillReceiveProps(newProps) {
        const {customValueData} = this.props;        
        if(typeof customValueData.period !== undefined) {
            this.setState({
                customValue: {
                    _id: newProps.customValueData._id,
                    period: newProps.customValueData.period,
                    extraPagIbig: newProps.customValueData.extraPagIbig,
                }
            });
        }
    }

    handleFormChange = (e) => {
        const { target } = e;
        const { name, value } = target;
    
        this.setState(prevState => ({
            customValue: {
                ...prevState.customValue,
                [name]: value,
            }
        }))
        
      }

      handleDateChange = (date) => {
        this.setState(prevState => ({
            customValue: {
                ...prevState.customValue,
                period: date
            }
        }));
      }
    
    render() {

        const {
            showModal,
            closeModal,
            modalType,
            handleCustomValue
        } = this.props;

          const {
              extraPagIbig,
              period,
          } = this.state.customValue;
        return(


            <Modal 
                show={showModal} 
                onHide={closeModal} 
                className="confirm-modal"
            >
                <Modal.Header>
                <Modal.Title>{modalType === "create" ? "Add a value" : "Edit your value"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
{/*                     <h4 className="text-center">{modalType === "create" ? "Add a value to table" : "Edit your value"}</h4>*/}                    <div className="d-flex">
                        <FormGroup>
                            <ControlLabel>Period</ControlLabel>
                            <DatePicker
                                dateFormat="MMMM/yyyy"
                                className="form-control"
                                showMonthYearPicker
                                onChange={(period) => this.handleDateChange(period)}
                                dropdownMode="select"
                                selected={Date.parse(period)}
                                placeholderText="xx/xxxx"
                            />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Extra Pag-Ibig</ControlLabel>
                            <CurrencyInput
                                name="extraPagIbig"
                                placeholder="PHP 0.00"
                                price={extraPagIbig}
                                onChange={(value) => this.handleFormChange({ target: { name: "extraPagIbig", value } })}
                            />
                          </FormGroup>
                    </div>
                    {this.props.error &&
                        <Alert bsStyle="danger">
                            {this.props.error}
                        </Alert>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button 
                      bsStyle="primary" 
                      pullRight 
                      fill
                      onClick={() => handleCustomValue(this.state)}
                      style={{
                          textTransform: "capitalize"
                        }}
                    >
                        {modalType || "Edit"}
                    </Button>
                    <Button 
                      bsStyle="danger" 
                      pullRight 
                      fill
                      style={{
                        marginRight: "10px"
                      }}
                      onClick={() => closeModal()}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default CustomValueModal